import { initOneDigitalAdvisors } from './OneDigitalState';

describe('OneDigitalState', () => {
  test('initOneDigitalAdvisors returns an array of advisors', () => {
    expect(initOneDigitalAdvisors()).toEqual(
      expect.arrayContaining([
        expect.objectContaining({ advisorIndex: 1 }),
        expect.objectContaining({
          questions: expect.objectContaining({
            advisorEmail: expect.objectContaining({
              value: 'britt.wells+onedigitalAJ@shiftdsm.com',
            }),
          }),
        }),
      ]),
    );
  });
});
